"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _constants = require("../../constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Headings = require("../Headings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Alert = props => {
  return /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({
    elevation: 5,
    variant: "outlined"
  }, props));
};

const TypeTitle = (0, _styledComponents.default)(_Headings.Subtitle1)`
	text-transform: capitalize;
`;
const Toaster = (0, _core.withStyles)(() => ({
  toaster: {
    zIndex: '999',
    borderRadius: '8px',
    backgroundColor: _constants.colours.white,
    '&.error .MuiAlert-root': {
      border: `solid 2px ${_constants.colours.toaster.errorBorder}`,
      backgroundColor: _constants.colours.toaster.errorBackground
    },
    '&.warning .MuiAlert-root': {
      border: `solid 2px ${_constants.colours.toaster.warningBorder}`,
      backgroundColor: _constants.colours.toaster.warningBackground
    },
    '&.success .MuiAlert-root': {
      border: `solid 2px ${_constants.colours.toaster.successBorder}`,
      backgroundColor: _constants.colours.toaster.successBackground
    },
    '&.info .MuiAlert-root': {
      border: `solid 2px ${_constants.colours.toaster.infoBorder}`,
      backgroundColor: _constants.colours.toaster.infoBackground
    }
  },
  alert: {
    display: 'flex',
    alignItems: 'center',
    width: '85vw',
    maxWidth: '600px',
    height: '70px',
    borderRadius: '8px',
    '& .MuiAlert-icon': {
      fontSize: '38px',
      padding: 0,
      marginLeft: '0'
    },
    '& .MuiAlert-message': {
      fontSize: _constants.fontSizes.body,
      color: _constants.colours.font
    },
    '& .MuiAlert-action': {
      fontSize: _constants.fontSizes.subtitle1,
      color: _constants.colours.inactiveState
    }
  }
}))(({
  classes,
  message,
  type,
  autoHideDuration,
  children,
  onClose,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_core.Snackbar, _extends({
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    className: `${classes.toaster} ${type}`,
    onClose: onClose,
    autoHideDuration: type === 'error' ? null : autoHideDuration
  }, props), /*#__PURE__*/_react.default.createElement(Alert, {
    iconMapping: {
      success: /*#__PURE__*/_react.default.createElement(_CheckCircleOutline.default, {
        fontSize: "inherit"
      }),
      info: /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
        fontSize: "inherit"
      })
    },
    className: classes.alert,
    severity: type,
    action: onClose && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "close",
      color: "primary",
      size: "medium",
      onClick: () => {
        onClose();
      }
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      fontSize: "inherit"
    }))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(TypeTitle, null, type), message)));
});
Toaster.propTypes = {
  message: _propTypes.default.string,
  type: _propTypes.default.oneOf(['info', 'warning', 'success', 'error']),
  onClose: _propTypes.default.func
};
Toaster.defaultProps = {
  type: 'info'
};
var _default = Toaster;
exports.default = _default;